import IpsEditor from './IpsEditor.vue';
import '../../../styles/custom.scss';

export default IpsEditor;
